<template>
    <div class="ng-overlay" v-if="opened">
        <div class="ng-gallery-content">
            <div class="gallery-loading" v-if="loading"><div></div></div>
            <a class="close-popup" v-on:click="closeGallery()">
                <svg class="svg-icon" viewBox="0 0 18 18">
                    <path fill="none" d="M15.898,4.045c-0.271-0.272-0.713-0.272-0.986,0l-4.71,4.711L5.493,4.045c-0.272-0.272-0.714-0.272-0.986,0s-0.272,0.714,0,0.986l4.709,4.711l-4.71,4.711c-0.272,0.271-0.272,0.713,0,0.986c0.136,0.136,0.314,0.203,0.492,0.203c0.179,0,0.357-0.067,0.493-0.203l4.711-4.711l4.71,4.711c0.137,0.136,0.314,0.203,0.494,0.203c0.178,0,0.355-0.067,0.492-0.203c0.273-0.273,0.273-0.715,0-0.986l-4.711-4.711l4.711-4.711C16.172,4.759,16.172,4.317,15.898,4.045z"></path>
                </svg>
            </a>
            <a class="nav-left" v-on:click="prevImage()">
                <svg class="svg-icon" viewBox="0 0 20 20">
                    <path fill="none" d="M8.388,10.049l4.76-4.873c0.303-0.31,0.297-0.804-0.012-1.105c-0.309-0.304-0.803-0.293-1.105,0.012L6.726,9.516c-0.303,0.31-0.296,0.805,0.012,1.105l5.433,5.307c0.152,0.148,0.35,0.223,0.547,0.223c0.203,0,0.406-0.08,0.559-0.236c0.303-0.309,0.295-0.803-0.012-1.104L8.388,10.049z"></path>
                </svg>
            </a>
            <img v-if="!loading" :src="imgSrc" v-on:click="nextImage()" class="effect" />
            <a class="nav-right" v-on:click="nextImage()">
                <svg class="svg-icon" viewBox="0 0 20 20">
                    <path fill="none" d="M11.611,10.049l-4.76-4.873c-0.303-0.31-0.297-0.804,0.012-1.105c0.309-0.304,0.803-0.293,1.105,0.012l5.306,5.433c0.304,0.31,0.296,0.805-0.012,1.105L7.83,15.928c-0.152,0.148-0.35,0.223-0.547,0.223c-0.203,0-0.406-0.08-0.559-0.236c-0.303-0.309-0.295-0.803,0.012-1.104L11.611,10.049z"></path>
                </svg>
            </a>
            <div class="info-text">
                <div class="game-name">{{ artwork.title }}</div>
                <div v-for="artist in artwork.info">
                    <div class="game-author">{{ artist.author }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'popup',
    props: ['artworks', 'imageindex', 'closemodal'],
    data() {
        return {
            opened: false,
            loading: true,
            imgSrc: null,
            artwork: null
        }
    },
    created() {
        this.openGallery(this.imageindex);
        this.bindWindowControls();
    },
    beforeDestroy() {
        this.discardListeners();
    },
    methods: {
        closeGallery() {
            this.opened = false;
            this.closemodal();
        },

        prevImage() {
            this.loading = true;
            this.currentImageIndex--;
            if (this.currentImageIndex < 0) {
                this.currentImageIndex = this.artworks.length-1  ;
            }
            this.openGallery(this.currentImageIndex);
        },

        nextImage() {
            this.loading = true;
            this.currentImageIndex++;
            if (this.artworks.length === this.currentImageIndex) {
                this.currentImageIndex = 0;
            }
            this.openGallery(this.currentImageIndex);
        },

        openGallery(index) {
            if(!index) {
                this.currentImageIndex = 1;
            }
            this.currentImageIndex = index;
            this.opened = true;
            for (var i = 0; i < this.artworks.length; i++) {
                if (i === this.currentImageIndex ) {
                    this.imgSrc = this.artworks[i].img;
                    this.artwork = this.artworks[i];
                    this.loading = false;
                    break;
                }
            }
        },

        bindWindowControls() {
            window.addEventListener('keydown', this.onKey);
        },
        discardListeners() {
            window.removeEventListener('keydown', this.onKey);
        },
        onKey(event) {
            if (event.code === 'Escape' || event.keyIdentifier === 'U+001B') {
                this.closeGallery();
            }

            if (event.code === 'ArrowRight' || event.keyIdentifier === 'Right') {
                this.nextImage();
            }

            if (event.code === 'ArrowLeft' || event.keyIdentifier === 'Left') {
                this.prevImage();
            }
        }
    }


}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Popup.vue